/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 4/11/2023
 */


import BaseProfile from "@shared/Profile/BaseProfile.js";
import AssignStats from "@shared/Profile/AssignStats.js";
import {Type} from "@qwoach/class-transformer-wrapper";
import {ProfileTypeEnum} from "@shared/Profile/ProfileTypeEnum.js";
import CommonObject from "@shared/CommonObject.js";

export default class TeamMemberProfile extends BaseProfile {

	@Type(() => AssignStats)
	assignStats: AssignStats = new AssignStats();


	constructor(name, email) {
		super(name, email, ProfileTypeEnum.TEAM_MEMBER);
		this.syncRuleItemMyIdForOwner()
	}

	regenerateId(){
		// we use this.id as the id for the corresponding UserProfile and AuthUser.
		// Auth system uses 28 char long ids to minimize collisions while doc.id is 20 char long.
		// so we regenerate the id here to make sure it is 28 char long
		if(CommonObject.dataManager){
			this.id = CommonObject.dataManager.generateUid()
		} else {
			this.id = null
		}
		// console.log("regenerateId: CommonObject.dataManager = ", CommonObject.dataManager, ", this = ", this)
	}


	getAssignedClientsCount() {
		return this.assignStats.getClientsCount();
	}

	getAssignedResourcesCount() {
		return this.assignStats.getResourcesCount();
	}

	getAssignedSessionTypesCount(){
		return this.assignStats.getSessionTypesCount();
	}

}
